export class DeviceParamLirisV3TriggerData {

    public activated: boolean;
    public channel: number;
    public timeOrThreshold: number;
    public amplOrHyst: number;
    public preTrigger: number;
    public postTrigger: number;
    public effect: number;
   // public status: boolean;
}
